'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var core = require('@material-ui/core');
var CardContent = _interopDefault(require('@material-ui/core/CardContent'));
var styledComponents = require('./styled-components.js');

var CardWithTitle = function (props) {
    var title = props.title, _a = props.underline, underline = _a === void 0 ? false : _a, children = props.children, style = props.style, _b = props.titlePaddingOverride, titlePaddingOverride = _b === void 0 ? '1rem 1.5rem' : _b;
    return (React__default.createElement(styledComponents.StyledCard, { style: style },
        React__default.createElement(CardContent, { style: { padding: titlePaddingOverride } }, title),
        underline && React__default.createElement(core.Divider, { "data-testid": 'divider' }),
        children));
};

module.exports = CardWithTitle;
